import { GeneralModel } from "./general.model";

export class AccountingAccount extends GeneralModel {
}